type Video = 'youtube' | 'vimeo' | 'video' | null
interface VideoUrlOptions {
    autoplay?: boolean
    enableJsApi?: boolean
}

export const setAutoplay = (url: string) => {
    return formatVideoUrl(url, { autoplay: true });
};

export const formatVideoUrl = (url: string, options: VideoUrlOptions = {}): string => {
    const { autoplay = false, enableJsApi = false } = options;
    const hasAutoplay = url.includes("autoplay=1");
    const hasEnableJsApi = url.includes("enablejsapi=1");

    if (hasAutoplay && (!enableJsApi || hasEnableJsApi)) {
        return url;
    }

    const videoType = getVideoType(url);

    const params: string[] = [];
    if (autoplay) params.push('autoplay=1');
    if (enableJsApi) params.push('enablejsapi=1');
    const queryString = params.join('&');

    if (!queryString) {
        return url;
    }

    const isYouTube = videoType === 'youtube' && !url.includes("embed");
    if (isYouTube) {
        const videoIdMatch = url.match(/(?:v=|youtu\.be\/|\/(?:shorts|live|embed)\/)([0-9A-Za-z_-]{11})(?:[?&#]|$)/)
            || url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})(?:[?&#]|$)/);
        const videoId = videoIdMatch ? videoIdMatch[1] : null;
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}?${queryString}`;
        }
    }

    if (videoType === 'vimeo') {
        const videoIdMatch = url.match(/vimeo\.com\/(?:.*\/)?(\d+)(?:[?#].*)?$/);
        const videoId = videoIdMatch ? videoIdMatch[1] : null;

        if (videoId) {
            return `https://player.vimeo.com/video/${videoId}?${queryString}`;
        }
    }

    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}${queryString}`;
};

export const getVideoMimeType = (url: string): string => {
    const extractExtension = (path: string): string | undefined => {
        const filename = path.substring(path.lastIndexOf('/') + 1)
        const dotIndex = filename.lastIndexOf('.')
        if (dotIndex > -1 && dotIndex < filename.length - 1) {
            return filename.substring(dotIndex + 1).toLowerCase()
        }
        return undefined
    }

    let extension: string | undefined
    try {
        const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://local');
        extension = extractExtension(parsed.pathname || '')
    } catch {
        const clean = url.split('?')[0].split('#')[0]
        extension = extractExtension(clean)
    }
    switch (extension) {
        case 'webm':
            return 'video/webm'
        case 'ogg':
        case 'ogv':
            return 'video/ogg'
        case 'mov':
            return 'video/quicktime'
        default:
            return 'video/mp4'
    }
}

export const getVideoType = (url: string | undefined): Video => {
    if (!url?.trim().length) return null;
    if (url.includes('youtube') || url.includes('youtu.be')) return 'youtube'
    if (url.includes('vimeo')) return 'vimeo'
    return 'video'
}